// extracted by mini-css-extract-plugin
export default {"d_bet":"FocusTags_d_bet__Vhxvm","main":"FocusTags_main__mGUHN","firstP":"FocusTags_firstP__tmXxo"};